tmPager = function () {
};
tmPager.prototype =
{
    create: function (_settings) {
        this.settings = _settings;

        if (!this.settings.page_size) {
            this.settings.page_size = 20;
        }
        this.order = {};
        this.pageNumber = 1;
        this.items = [];
        this.filterComponents = [];
        this.orderComponent = '';
        this.orderBy = null;
        this.buttons = null;
        $(_settings.id).empty();
        this.container = $('<div></div>');
        $(_settings.id).append(this.container);
        this.currentHash = '';
        this.processHash();
        this.filter();
        this.orderComponent = _settings.orderComponent ? _settings.orderComponent : '';
        this.orderBy = _settings.orderBy ? _settings.orderBy : (_settings.orderComponent ? 'asc' : null);
        this.lastRequestedPage = this.settings.url;
    },
    processHash: function () {
        var fields = {};
        this.orderComponent = '';
        this.orderBy = '';
        this.orderBy = null;
        this.filterComponents = [];
        try {
            var hash = window.location.hash.slice(window.location.hash.indexOf('#') + 1);

            if (this.currentHash == hash) {
                return false;
            }

            var vars = JSON.parse(hash);

            if (vars.pn) {
                this.pageNumber = vars.pn;
            }

            if (vars.order) {
                if (vars.order.oc) {
                    this.orderComponent = vars.order.oc;
                }
                if (vars.order.ob) {
                    this.orderBy = vars.order.ob;
                }
            }

            if (vars.filter) {
                for (var j in vars.filter) {
                    var f = vars.filter[j];
                    f.value = encodeURIComponent(f.value);
                    fields[f.field] = f.value;
                    this.filterComponents.push(f);
                }
            }
        } catch (e) {
        }

        if (this.settings.onFilterData) {
            this.settings.onFilterData(fields);
        }

        return true;
    },
    attachButtons: function (_buttons) {
        this.buttons = _buttons;
        this.buttons.pager = this;
    },
    busy: function () {
        start_spin();
    },
    ready: function () {
        end_spin();
    },
    getFilter: function () {
        return this.filterComponents;
    },
    filter: function (_data, filterAsStrict) {
        filterAsStrict = typeof filterAsStrict !== 'undefined' ? filterAsStrict : false;

        this.filterComponents = [];
        if (this.settings.filter) {
            this.filterComponents = this.settings.filter.slice(0);
        }
        for (var j in _data) {
            if(filterAsStrict) {
                this.filterComponents.push({field: j, value: _data[j], strict: true});
            } else {
                this.filterComponents.push({field: j, value: _data[j]});
            }
        }
        return this;
    },
    strictFilter: function (_data) {
        this.filter(_data, true);
    },
    removeFilter: function (key) {
        this.filterComponents = _.filter(this.filterComponents, function(filter) { return filter.field != key });
    },
    empty: function () {
        return _.isEmpty(this.items);
    },
    getItems: function () {
        return this.settings.items;
    },
    page: function (_pageNumber) {
        this.busy();

        if (this.settings.initial) {
            this.onPage(this.settings.initial);
            this.settings.initial = null;

        } else {
            if (this.settings.url) {
                var self = this;
                $.get(this.pageRequest(_pageNumber))
                    .done(function (_data) {
                        self.onPage(_data);
                        self.afterPage();
                    });
            } else {
                this.onPage(this.items);
                this.afterPage();
            }
        }

        return this;
    },
    pageRequest: function (_pageNumber) {
        if (_pageNumber) {
            this.pageNumber = _pageNumber;
        }

        var hashData = {pn: this.pageNumber};
        var request = this.settings.url.slice(0, -1);

        var pagerOffset = this.settings.page_size * (this.pageNumber - 1) + 1;
        var pagerLimit = this.settings.page_size;

        var pager = ['pager[offset]=' + pagerOffset, 'pager[limit]=' + pagerLimit];

        var filter = [];
        var order = [];

        if (this.filterComponents.length) {
            hashData.filter = [];
            for (var j in this.filterComponents) {
                var f = this.filterComponents[j];
                filter.push('filter[' + encodeURIComponent(f.field) + ']=' + encodeURIComponent((f.strict ? f.value : '%' + f.value + '%')));
                hashData.filter.push(f);
            }
        }

        if (this.orderComponent) {
            order = ['sort=' + (this.orderBy == 'desc' ? '-' : '') + this.orderComponent];
            hashData.order = {oc: this.orderComponent, ob: this.orderBy};
        }

        this.currentHash = JSON.stringify(hashData);

        var queryStringParams = filter.concat(order);

        this.lastRequestedPage = request + (_.isEmpty(queryStringParams) ? '' : '?' + queryStringParams.join('&'));

        queryStringParams = queryStringParams.concat(pager);

        return request + (_.isEmpty(queryStringParams) ? '' : '?' + queryStringParams.join('&'));
    },
    getLastRequestedPage: function () {
        return this.lastRequestedPage;
    },
    afterPage: function () {
    },
    getItems: function() {
        // We know there are no functions in the data array.
        return JSON.parse(JSON.stringify(this.items));
    },
    onPage: function (_data) {
        if (this.settings.onPageCreate) {
            this.settings.onPageCreate();
        }

        if (_data.items) {
            this.items = _data.items;
        } else {
            this.items = _data;
        }

        if (_data.info) {
            this.pageNumber = _data.info.page;
            this.totalPages = _data.info.total;
            this.total_items = _data.info.total_items;
        } else {
            this.pageNumber = 1;
            this.totalPages = 1;
            this.total_items = _.size(this.items);
        }

        if (_.size(this.items) > 0) {
            for (var i in this.items) {
                this.settings.appendItem(this.items[i]);
            }
            var self = this;

            if (this.buttons) {
                this.buttons.render({item_count: self.total_items, pn: self.pageNumber, tp: self.totalPages});
            }
            if (this.settings.onPageCreated) {
                this.settings.onPageCreated();
            }
        }
        else {
            var col_count = $(this.container).find('tr.pager_header > th').size();
            $(this.container).find('tr.pager_header').after($('<tr class="pager_empty"><td colspan="' + col_count + '"><div class="empty_listing">' + _T(this.settings.empty_listing_text ? this.settings.empty_listing_text : 'no_items_found_for_list_pager') + '</div></td></tr>'));
        }

        this.ready();

        this.container.trigger('pager:page');

        return this;
    },
    onOrder: function (_id, _order) {
        if (this.orderComponent != _id) {
            this.orderBy = null;
        }

        this.orderComponent = _id;

        if (typeof(_order) != 'undefined') {
            this.orderBy = _order;
        } else {
            switch (this.orderBy) {
                case 'asc':
                    this.orderBy = 'desc';
                    break;
                case 'desc':
                    this.orderBy = null;
                    break;
                case null:
                    this.orderBy = 'asc';
                    break;
            }
        }

        if (this.orderBy == null) {
            this.orderComponent = null;
        }

        this.updateChevrons();

        return this;
    },
    updateChevrons: function () {
        for (var j in this.order) {
            this.order[j].removeClass('a d');
        }

        try {
            if (this.orderComponent) {
                if (this.orderBy == 'asc') {
                    this.order[this.orderComponent].addClass('a');
                }
                if (this.orderBy == 'desc') {
                    this.order[this.orderComponent].addClass('d');
                }
            }
        } catch (e) {
        }
    }
};

tmButtons = function () {
};
tmButtons.prototype =
{
    create: function (_settings) {
        this.settings = _settings || {};

        var toolbar = $('<div class="pager-toolbar ui-helper-clearfix"></div>');
        this.buttonset = $('<div class="pager-buttonset ui-helper-clearfix"></div>');
        toolbar.append(this.buttonset);

        this.container = toolbar;
        this.pager = null;
        return this.container;
    },
    button: function (_p, _t, _link, _primary, _secondary, _tp) {
        var el;
        var p = this.pager;

        if (_tp) {
            el = $('<input />')
                .val(_t)
                .addClass('pager-input ui-state-active std-input std-textfield')
                .on('change', function (e) {
                    var destination = $(this).val();

                    if ($.isNumeric(destination) && (destination > 0 && destination <= _tp)) {
                        p.page(destination);
                    } else {
                        $(this).val(_t);
                    }

                    return false;
                });
        } else {
            el = $('<button class="pager-button">' + _t + '</button>');

            if (_primary && _secondary) {
                el.button({text: false, icons: {primary: _primary, secondary: _secondary}});
            } else if (_primary) {
                el.button({text: false, icons: {primary: _primary}});
            } else if (_secondary) {
                el.button({text: false, icons: {secondary: _secondary}});
            } else {
                el.button();
            }

            if (_link) {
                el.click(function () {
                    p.page(_p);
                    return false;
                });
            } else {
                el.button('disable');
            }
        }

        return el;
    },
    render: function (_data) {
        this.buttonset.html('');
        this.buttonset.append(this.button(1, _T('first'), ( _data.pn > 1 ), 'ui-icon-seek-prev'));
        this.buttonset.append(this.button(_data.pn - 1, _T('previous'), ( _data.pn > 1 ), 'ui-icon-seek-first'));

        var init = (_data.pn - 2 < 1) ? 1 : _data.pn - 2;
        var last = (_data.pn + 2 > _data.tp) ? _data.tp : _data.pn + 2;

        for (var j = init; j <= last; j++) {
            var p = j;
            if (j == last && j < _data.tp) {
                p = j + " ...";
            }
            if (j == init && j > 1) {
                p = "... " + j;
            }

            if (j != _data.pn) {
                this.buttonset.append(this.button(j, p, _data.pn));
            } else {
                this.buttonset.append(this.button(j, p, false, false, false, _data.tp)
                    .addClass('ui-state-active')
                    .removeClass('ui-state-disabled')
                    .removeClass('ui-button-disabled'));
            }
        }

        this.buttonset.append(this.button(_data.pn + 1, _T('next'), ( _data.pn < _data.tp ), 'ui-icon-seek-end'));
        this.buttonset.append(this.button(_data.tp, _T('last'), ( _data.pn < _data.tp ), null, 'ui-icon-seek-next'));

        if (_data.item_count > 0) {
            this.buttonset.append($("<span class='pager_record_count'>(" + _T('%s records on %s pages', [_data.item_count, _data.tp]) + ")</span>"));
        }
    }
};

createTablePager = function (_settings) {
    var c = $('<table></table>');
    if (_settings.headers) {
        var tr = $('<tr class="pager_header"></tr>');
        for (var j in _settings.headers) {
            var h = _settings.headers[j];
            var th = $('<th></th>');
            if (h.oId) {
                var self = _settings.pager;
                var a = $('<a href="#">' + h.id + '</a>');
                a.bind('click', {id: h.oId}, function (_data) {
                    self.onOrder(_data.data.id);
                    self.page();
                    return false;
                });
                th.append(a).addClass('order');
                _settings.pager.order[h.oId] = a;
                if (h.colspan) {
                    th.attr('colspan', h.colspan);
                }
            } else {
                th.html(h.id);
            }
            if (h.w) {
                th.css('width', h.w);
            }
            if (h.c) {
                th.addClass(h.c);
            }
            tr.append(th);
        }
        c.append(tr);
    }
    return c;
};

createListPager = function (_settings) {
    return $('<ul></ul>');
};

switchToList = function (_settings) {
    var container = _settings.createListPager ?_settings.createListPager() :  createListPager();

    var el = _settings.pager.container;
    el.html(container);

    if (_settings.height) {
        el.css('height', _settings.height);
    }
    if (_settings.size) {
        _settings.pager.settings.page_size = _settings.size;
    }

    _settings.pager.settings.appendItem = function (_item) {
        container.append(_settings.createListItem(_item));
    };
    _settings.pager.settings.onPageCreated = null;
    _settings.pager.settings.onPageCreate = function () {
        container.html('');
    };
    _settings.pager.page();
    _settings.pager.updateChevrons();
};

switchToTable = function (_settings) {
    var container = createTablePager(_settings);
    var el = _settings.pager.container;
    el.html(container);

    if (_settings.height) {
        el.css('height', _settings.height);
    }
    if (_settings.size) {
        _settings.pager.settings.page_size = _settings.size;
    }

    _settings.pager.settings.appendItem = function (_item) {
        container.append(_settings.createRow(_item));
    };
    _settings.pager.settings.onPageCreate = function () {
        container.find('tr.item,tr.pager_empty').remove();
    };
    _settings.pager.page();
    _settings.pager.updateChevrons();

    if (_settings.afterSwitchToTable) {
        _settings.afterSwitchToTable();
    }
};
